module.exports = __webpack_public_path__ + "img/VL_18_02.a332a548.png";